export const setAuthCookie = (data: any) => {
    const expires = new Date();
    expires.setHours(24, 0, 0, 0);
    document.cookie = `auth=${encodeURIComponent(JSON.stringify(data))}; expires=${expires}; path=/; SameSite=Strict`;
};

export const getCookie = (name: string = 'auth') => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    const cookieVal = match ? decodeURIComponent(match[2]) : null;
    if (cookieVal) {
        try {
            return JSON.parse(cookieVal);
        } catch (e) {
            return null;
        }
    }
    return null;
};

export const removeAuthCookie = () => {
    document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
};
